/**
 * Created by slava on 24.03.17.
 */

const ExpInfoWindow = CleverappsWindow.extend({
    onWindowLoaded: function () {
        const content = this.generateContent();

        this._super({
            title: Messages.get("ExpInfoWindow.Title"),
            name: "expinfowindow",
            content
        });

        cleverapps.paymentsLogic.onChangeStatus(this.updateButtons.bind(this), this);

        this.updateButtons();
    },

    updateButtons: function () {
        this.list.forEach((item) => {
            if (connector.payments.isConnected()) {
                item.button.enable();
            } else {
                item.button.disable();
            }
        });
    },

    generateProductOption: function (optionId, spriteFileName) {
        const styles = cleverapps.styles.ExpInfoWindow;
        const product = Product.CreateById(optionId);

        const optionButton = new cleverapps.UI.Button({
            text: product.getCurrentPrice(),
            onClicked: function () { 
                product.buy((success) => {
                    if (success) {
                        this.close();
                    }
                });
            }.bind(this),
            width: styles.button.width,
            height: styles.button.height
        });

        const expAmount = new TextWithIcon(`${product.reward.exp}%%`, {
            font: cleverapps.styles.FONTS.EXP_INFO_WINDOW_AMOUNT_TEXT || cleverapps.styles.FONTS.WINDOW_TEXT,
            icons: {
                "%%": bundles.reward_icons.frames.reward_exp_png
            }
        });

        const optionIcon = new cc.Sprite(spriteFileName);

        const productNode = new cleverapps.Layout([optionIcon, expAmount, optionButton], {
            direction: cleverapps.UI.VERTICAL,
            margin: styles.button.itemsMargin
        });
        productNode.button = optionButton;
        productNode.setAnchorPoint(0.5, 0);
        return productNode;
    },

    generateContent: function () {
        const styles = cleverapps.styles.ExpInfoWindow;

        const descriptionText = cleverapps.UI.generateOnlyText(Messages.get("ExpInfoWindow.Message"), cleverapps.styles.FONTS.WINDOW_SMALL_TEXT);
        descriptionText.setDimensions(styles.text.width, 0);
        descriptionText.setHorizontalAlignment(cc.TEXT_ALIGNMENT_CENTER);

        const offerText = cleverapps.UI.generateOnlyText(Messages.get("ExpInfoWindow.BuyMessage"), cleverapps.styles.FONTS.WINDOW_SMALL_TEXT);
        offerText.setDimensions(styles.text.width, 0);
        offerText.setHorizontalAlignment(cc.TEXT_ALIGNMENT_CENTER);

        this.list = [
            this.generateProductOption("buyExp10", bundles.exp_window.frames.small_exp_box),
            this.generateProductOption("buyExp150", bundles.exp_window.frames.exp_box)
        ];

        const offerOptions = new cleverapps.Layout(this.list, {
            direction: cleverapps.UI.HORIZONTAL,
            margin: styles.buttonsMargin
        });

        return new cleverapps.Layout([descriptionText, offerText, offerOptions], {
            direction: cleverapps.UI.VERTICAL,
            margin: styles.margin
        });
    },

    listBundles: function () {
        return ["exp_window"];
    }
});

cleverapps.styles.ExpInfoWindow = {
    margin: 30,
    buttonsMargin: 50,

    text: {
        width: 600
    },

    exp: {
        width: 400,
        height: 200
    },

    button: {
        itemsMargin: 3,
        width: 300,
        height: 100
    }
};